import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from "react-router-redux/actions";

import { detailsSelectors } from "reducers/administration";
import { actions as formActions } from "reducers/form";

import PermissionConfirm from "pages/administration/_components/confirmations/PermissionConfirm";
import { selectors as administrationUsersSelector, actions as userActions } from "reducers/administration/users";

const mapStateToProps = (state) => {
    const user = detailsSelectors.getUser(state);
    const userInfo = administrationUsersSelector.getUserInfo(state, user);

    return {
        user,
        userInfo,
        credentialGroups: detailsSelectors.getCredentialGroups(state),
    };
};

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(userActions, dispatch),
    formActions: bindActionCreators(formActions, dispatch),
    routerActions: bindActionCreators(routerActions, dispatch),
    schemeName: "medium",
});

export default connect(mapStateToProps, mapDispatchToProps)(PermissionConfirm);
